/* @ngInject */
const typeService = () => {
  const self = {}

  self.text = (_maxlength = 100) => {
    return {
      nature: 'text',
      maxlength: _maxlength,
      minlength: 0,
      pattern: null,
      format: null,
      excelNature: 'text',
    }
  }

  self.date = {
    nature: 'date',
    maxlength: 10,
    minlength: 10,
    pattern: new RegExp('^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$'),
    format: 'JJ/MM/AAAA',
    mask: '99/99/9999',
    excelFormat: 'dd/mm/yyyy',
    excelNature: 'date',
  }

  self.integer = {
    nature: 'number',
    maxlength: 10,
    minlength: 0,
    pattern: new RegExp('^[0-9]{0,15}$'),
    format: 'Entier : 1, 2, 3, 53...',
    excelFormat: '### ##0',
    excelNature: 'integer',
  }

  self.decimal = {
    nature: 'number',
    maxlength: 10,
    minlength: 0,
    pattern: new RegExp('^[0-9]{0,6}([.,]{1}[0-9]{0,2}){0,1}$'),
    format: 'Décimal : 000 000.00',
    excelFormat: '### ##0.00',
    excelNature: 'decimal',
  }

  self.euro = {
    nature: 'number',
    maxlength: 10,
    minlength: 0,
    pattern: new RegExp('^[0-9]{0,6}([.,]{1}[0-9]{0,2}){0,1}$'),
    format: 'Euro : 000 000.00 €',
    excelFormat: '### ##0.00 €',
    excelNature: 'decimal',
  }

  self.cp = {
    nature: 'text',
    maxlength: 10,
    minlength: 0,
    pattern: new RegExp('^[0-9]{4,5}$'),
    format: 'Code postal : 00000',
    excelNature: 'text',
  }

  self.select = {
    nature: 'select',
  }

  self.password = {
    nature: 'password',
    maxlength: 50,
    minlength: 6,
    pattern: new RegExp('^[0-9a-zA-Z\\S]{6,}$'),
    format: 'Le mot de passe n\'est pas assez fort',
    excelNature: '',
  }

  self.textarea = {
    nature: 'textarea',
    maxlength: 255,
    minlength: 0,
    pattern: null,
    format: null,
    excelNature: 'text',
  }

  self.email = {
    nature: 'email',
    maxlength: 100,
    minlength: 0,
    pattern: new RegExp('[\\w-_.]+[@][\\w-_]+([.][\\w-_]+)*'),
    format: 'L\'e-mail est invalide',
    excelNature: 'text',
  }

  self.wagonId = {
    nature: 'text',
    maxlength: 20,
    minlength: 0,
    pattern: null,
    format: 'L\'id du wagon est invalide',
    excelNature: 'wagonId',
    mask: '?9?9\\ ?9?9\\ ?9?9?9\\ ?9?9?9?9\\ -\\ ?9',
  }

  self.incompleteWagonId = {
    nature: 'text',
    maxlength: 50,
    minlength: 0,
    pattern: null,
    format: 'L\'id du wagon est invalide',
    excelNature: 'wagonId',
    mask: '?*?*-?*?*-?*?*?*-?*?*?*?*-?*',
  }

  self.percentage = {
    nature: 'text',
    maxlength: 50,
    minlength: 0,
    excelNature: 'percentage',
    excelFormat: '### ##0.00%',
  }

  return self
}

export default typeService



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/resources/types.resource.js